import type { OnInit } from '@angular/core';
import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import type { HelpArticle, HelpArticleKey } from '@shared/modules/help-desk/articles';
import { articles } from '@shared/modules/help-desk/articles';
import { HelpDeskService } from '@shared/modules/help-desk/help-desk.service';

@Directive({
    selector: '[appHelpArticle]'
})
export class HelpArticleDirective implements OnInit {
    private _article: HelpArticleKey;
    private _definition: HelpArticle;

    @Input() set appHelpArticle(value: HelpArticleKey | HelpArticle) {
        if (typeof value === 'string') {
            this._article = value;
            this._definition = articles[value] ?? null;
        } else {
            this._article = undefined;
            this._definition = value;
        }
    }

    constructor(
        private helpDesk: HelpDeskService,
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
    }

    ngOnInit(): void {
        if (!this._definition) {
            console.warn('Missing help article definition', this._article, this._definition);
            return;
        }

        const $element: HTMLElement = this.elementRef.nativeElement;

        this.renderer.setStyle($element, 'cursor', 'pointer');

        if ($element.tagName === 'A') {
            const url = this.helpDesk.articleUrl(this._definition);

            if (url?.length) {
                const $anchor = $element as HTMLAnchorElement;

                $anchor.href = url;
                $anchor.target = '_blank';
            }
        }
    }

    @HostListener('click', ['$event'])
    onClick($event: MouseEvent) {
        if (this._definition) {
            $event.preventDefault();

            this.helpDesk.open(this._definition, $event.metaKey);
        }
    }
}
